let itm = {
  bcg: require('./bcg_revise.png'),
  animals: require('./rev/bcg_anim_t.png'),
  items: [
    {
      // disable: true,
      bcg: require('./rev/bcg.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '4.8%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page000_game2',
          type: 'game',
        },
        {
          bcg: require('./rev/r.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '10',
          type: 'page',
        },
        // {
        //   disable: true,
        //   bcg: require('./rev/r1_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      // disable: true,
      bcg: require('./rev/bcg2.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '20.2%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p2.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page765_game0',
          type: 'game',
        },
        {
          bcg: require('./rev/r2.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '20',
          type: 'page',
        },
        // {
        //   bcg: require('./rev/r2_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      // disable: true,
      bcg: require('./rev/bcg3.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '35.7%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p3.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page765_game1',
          type: 'game',
        },
        {
          bcg: require('./rev/r3.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '30',
          type: 'page',
        },
        // {
        //   bcg: require('./rev/r3_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      // disable: true,
      bcg: require('./rev/bcg4.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '51.2%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p4.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page765_game2',
          type: 'game',
        },
        {
          bcg: require('./rev/r4.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '40',
          type: 'page',
        },
        // {
        //   bcg: require('./rev/r4_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      // disable: true,
      bcg: require('./rev/bcg5.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '66.6%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p5.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page765_game3',
          type: 'game',
        },
        {
          bcg: require('./rev/r5.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '50',
          type: 'page',
        },
        // {
        //   bcg: require('./rev/r5_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      // disable: true,
      bcg: require('./rev/bcg6.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '82%',
        height: '32.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/ispy.png'),
          cssStyle: {
            position: 'absolute',
            top: '35.2%',
            left: '24.2%',
            height: '54.6%',
            width: '51%',
          },
          redirect: 'page056_game1',
          type: 'game',
        },
      ],
    },
  ],
};

export default itm;
